import { put, select } from 'redux-saga/effects';

import { axiosSSO } from 'config';
import { selectSelectedUser } from 'store/addUserSlice/addUserSelectors';
import { addUserActions } from 'store/addUserSlice/addUserSlice';
import { notificationHandler } from 'utils/utils';
import store from '../store';
import { selectFormById } from './formControlSelectors';
import { formControlActions } from './formControlSlice';
import { errorCodeToMessageMap, getFormattedErrorMessage } from 'utils/formatErrorCode';
import { EMAIL_FIELD_NAME } from 'utils/constants';

export function* userConfigurationSaga({ payload: type }) {
    const selectedUser = yield select(selectSelectedUser);
    const formId = type.formId;

    yield put(formControlActions.setSubmitFormInProgress(true));

    try {
        const {
            form: { values, errors },
        } = yield select(selectFormById(formId));
        let isFormValid = true;

        Object.keys(errors).forEach((fieldName) => {
            if (errors[fieldName]) {
                isFormValid = false;
                store.dispatch(formControlActions.setFieldTouched({ formId, fieldName }));
            }
        });

        if (!isFormValid) {
            yield notificationHandler({
                title: 'Please fill required fields',
                variant: 'warning',
            });

            yield put(formControlActions.setSubmitFormInProgress(false));
            return;
        }
        if (type.formStatus === 'add') {
            const data = {
                username: values.username,
                password: values.password,
                superAdmin: values.superAdmin,
                terminationDate: values.terminationDate,
                email: values.email || null,
                active: values.active,
                applicationRoles: [
                    {
                        roleId: values.roleId,
                        applicationId: values.applicationId,
                    },
                ],
            };

            const response = yield axiosSSO.post(type.postUrl, data);
            if (response.status === 200) {
                // const id = response.data.id;
                yield put(addUserActions.fetchUsersStart());
                // yield put(addUserActions.fetchSelectedUserRolesStart({ userId: id }));
                yield put(addUserActions.setAddPopupVisible(false));
                // yield put(addUserActions.setSelectedUser(id));

                yield notificationHandler({
                    title: `SUCCESSFULLY ADDED USER`,
                    variant: 'success',
                });

                yield put(formControlActions.setSubmitFormInProgress(false));
            }
        }

        if (type.formStatus === 'put') {
            const data = {
                id: type.userId,
                applicationRoles: [
                    ...type.selectedUserRoles,
                    {
                        roleId: values.roleId,
                        applicationId: values.applicationId,
                    },
                ],
                email: selectedUser?.email || null,
            };

            const response = yield axiosSSO.put(type.putUrl, data);
            if (response.status === 200) {
                yield put(addUserActions.fetchUsersStart());
                yield put(addUserActions.fetchSelectedUserRolesStart({ userId: type.userId }));
                yield put(addUserActions.setAddRolePopupVisible(false));
                yield put(addUserActions.setSelectedRole(null));
                yield notificationHandler({
                    title: `SUCCESSFULLY ADDED ROLE`,
                    variant: 'success',
                });

                yield put(formControlActions.setSubmitFormInProgress(false));
            }
        }
    } catch (err) {
        const errMsg = getFormattedErrorMessage(err.response.data.error);
        let title = 'Error submitting data! ';
        if (errMsg === errorCodeToMessageMap.EMAIL_ALREADY_EXIST) {
            yield put(
                formControlActions.setFieldError({
                    formId,
                    fieldName: EMAIL_FIELD_NAME,
                    error: errMsg,
                })
            );
            yield put(
                formControlActions.setFieldTouched({
                    formId,
                    fieldName: EMAIL_FIELD_NAME,
                })
            );
        } else if (err.response?.status === 400) {
            const rawError = err.response?.data?.error ?? '';
            if (rawError.includes(']')) {
                title += rawError.split(']')[0].slice(1).replaceAll('_', ' ');
            } else {
                title += rawError.replaceAll('_', ' ');
            }
            yield notificationHandler({ title });
        } else if (err.response?.status === 409) {
            yield notificationHandler({ title: 'User with that name already exist' });
        } else if (err.response?.status === 500) {
            yield notificationHandler({ title: 'User already have that role!' });
        } else {
            yield notificationHandler({ title: errMsg });
        }
        yield put(formControlActions.submitFormFailed(JSON.stringify(err.message)));
    }
}
